export type NumberType = 'int' | 'float'

function isCharNumeric(charStr: string, numberType: NumberType) {
  if (numberType === 'float') {
    return !!/\d|\./.test(charStr)
  }

  return !!/\d/.test(charStr)
}

function isKeyPressedNumeric(event: any, numberType: NumberType) {
  var charStr = event.key
  return isCharNumeric(charStr, numberType)
}

export const getNumericCellEditor = (numberType: NumberType) => {
  class NumericCellEditor {
    focusAfterAttached: any
    eInput: any
    cancelBeforeStart: any
    numberType: NumberType = 'float'

    init(params: any) {
      this.focusAfterAttached = params.cellStartedEdit
      this.numberType = numberType
      // create the cell
      this.eInput = document.createElement('input')
      this.eInput.classList.add('ag-input-field-input')
      this.eInput.style.width = '100%'
      this.eInput.style.height = '100%'
      this.eInput.value =
        params.charPress && isCharNumeric(params.charPress, this.numberType) ? params.charPress : params.value

      this.eInput.addEventListener('keypress', (event: any) => {
        if (!isKeyPressedNumeric(event, this.numberType)) {
          this.eInput.focus()
          if (event.preventDefault) {
            event.preventDefault()
          }
        }
      })
    }

    getGui() {
      return this.eInput
    }

    afterGuiAttached() {
      if (this.focusAfterAttached) {
        this.eInput.focus()
        this.eInput.select()
      }
    }

    isCancelBeforeStart() {
      return this.cancelBeforeStart
    }

    isCancelAfterEnd() {
      return false
    }

    getValue() {
      return this.eInput.value
    }

    focusIn() {
      var eInput = this.getGui()
      eInput.focus()
      eInput.select()
    }
  }

  return NumericCellEditor
}
